<template>
    <div>
        <p class="uk-text-warning">{{ $t("user_docs.warning") }}</p>
        <div class="uk-grid-small uk-child-width-1-2@m uk-grid-match" uk-grid>
            <div v-for="(doc, i ) in res.doc_list" :key="i">
                <doc-form :doc="doc" :client-i-d="res.c_id" :id="'upload_' + i"></doc-form>
            </div>
        </div>
    </div>
</template>

<script>
    import DocForm from "@/components/DocForm";

    export default {
        name: "ClientDocList",
        components: {
            DocForm
        },
        props: {
            docsetID: { required: true, type: String },
        },
        created() {
            // fetch data if status unauthorized redirect to login page
            this.$http.get(`/user-doc-list/${ this.docsetID }/`)
                .then(res => {
                    if (res["err_text"]) {
                        this.$router.push({ name: "errorView", params: { message: res["err_text"] } });
                        return;
                    }
                    this.res = res.data;
                })
                .catch(err => {
                    this.$router.push({
                        name: "errorView",
                        params: {
                            message: err.response.statusText,
                            status: err.response.status
                        }
                    });
                })
        },
        data() {
            return {
                res: {
                    c_id: null,
                    doc_list: []
                }
            };
        },
    };
</script>

<style scoped>
    .flex-grow {
        flex-grow: 1;
    }
</style>